/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Voice_Agents_Handoff_Title7Inputs */

const en_svc_ai_voice_agents_handoff_title7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Handoff_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Human handoff and analytics`)
};

const ar_svc_ai_voice_agents_handoff_title7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Handoff_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التسليم البشري والتحليلات`)
};

const bn_svc_ai_voice_agents_handoff_title7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Handoff_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`মানব হস্তান্তর ও বিশ্লেষণ`)
};

const de_svc_ai_voice_agents_handoff_title7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Handoff_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menschliche Übergabe und Analysen`)
};

const es_svc_ai_voice_agents_handoff_title7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Handoff_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Derivación humana y analítica`)
};

const fr_svc_ai_voice_agents_handoff_title7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Handoff_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relais humain et analytique`)
};

const pt_svc_ai_voice_agents_handoff_title7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Handoff_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passagem humana e análise`)
};

const zh_svc_ai_voice_agents_handoff_title7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Handoff_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`人工转接与分析`)
};

const tr_svc_ai_voice_agents_handoff_title7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Handoff_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İnsana devir ve analitik`)
};

const ru_svc_ai_voice_agents_handoff_title7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Handoff_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Передача человеку и аналитика`)
};

const pl_svc_ai_voice_agents_handoff_title7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Handoff_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przekazanie człowiekowi i analityka`)
};

/**
* | output |
* | --- |
* | "Human handoff and analytics" |
*
* @param {Svc_Ai_Voice_Agents_Handoff_Title7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_voice_agents_handoff_title7 = /** @type {((inputs?: Svc_Ai_Voice_Agents_Handoff_Title7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Voice_Agents_Handoff_Title7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_voice_agents_handoff_title7(inputs)
	if (locale === "bn") return bn_svc_ai_voice_agents_handoff_title7(inputs)
	if (locale === "de") return de_svc_ai_voice_agents_handoff_title7(inputs)
	if (locale === "es") return es_svc_ai_voice_agents_handoff_title7(inputs)
	if (locale === "fr") return fr_svc_ai_voice_agents_handoff_title7(inputs)
	if (locale === "pt") return pt_svc_ai_voice_agents_handoff_title7(inputs)
	if (locale === "zh") return zh_svc_ai_voice_agents_handoff_title7(inputs)
	if (locale === "tr") return tr_svc_ai_voice_agents_handoff_title7(inputs)
	if (locale === "ru") return ru_svc_ai_voice_agents_handoff_title7(inputs)
	if (locale === "pl") return pl_svc_ai_voice_agents_handoff_title7(inputs)
	return en_svc_ai_voice_agents_handoff_title7(inputs)
});
export { svc_ai_voice_agents_handoff_title7 as "svc_ai-voice-agents_HANDOFF_title" }